(function bindCopyMailto() {
  const TIP_MS = 2500;
  let hideTimer = null;

  function emailFromMailto(href) {
    return (href || '')
      .replace(/^mailto:/i, '')
      .split('?')[0]
      .trim();
  }

  function fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    if (!ok) {
      throw new Error('copy failed');
    }
  }

  function showTip(anchor) {
    let tip = document.querySelector('.copy-mailto-tip');
    if (!tip) {
      tip = document.createElement('div');
      tip.className = 'copy-mailto-tip';
      tip.setAttribute('role', 'status');
      document.body.appendChild(tip);
    }

    tip.textContent = '複製成功';
    const rect = anchor.getBoundingClientRect();
    const placeBelow = rect.top < 48;
    tip.classList.toggle('is-below', placeBelow);
    tip.style.left = `${Math.round(rect.left + rect.width / 2)}px`;
    tip.style.top = `${Math.round(placeBelow ? rect.bottom : rect.top)}px`;
    tip.classList.add('is-visible');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => {
      tip.classList.remove('is-visible');
    }, TIP_MS);
  }

  function copyEmail(email) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(email);
    }
    fallbackCopy(email);
    return Promise.resolve();
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[href^="mailto:"]');
    if (!link) return;

    event.preventDefault();
    const email = emailFromMailto(link.getAttribute('href'));
    if (!email) return;

    copyEmail(email)
      .then(() => showTip(link))
      .catch(() => {
        try {
          fallbackCopy(email);
          showTip(link);
        } catch (e) {
          // ignore
        }
      });
  });
})();
